import api from 'api';

export const loadIntegrationsGrid = api('POST /api/integrations/grid');
